import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, MapPin, Camera, FileText } from "lucide-react";

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="bg-brand-navy text-white">
        <div className="container-x py-20 md:py-28">
          <div className="eyebrow !text-brand-cyan">About</div>
          <h1 className="mt-3 font-display text-4xl md:text-6xl font-bold leading-tight max-w-4xl">
            Hi-Tech Realty. Local property care for Chennai owners who cannot be present locally.
          </h1>
          <p className="mt-5 text-white/80 max-w-3xl">
            Founded by Chennai real-estate professionals, Hi-Tech Realty was built around one belief — every property owner deserves verified updates, not vague reassurances. We protect, monitor and manage your property with documented visits and transparent reporting.
          </p>
        </div>
      </section>

      <section className="section-pad grid md:grid-cols-2 gap-12 items-start">
        <div>
          <div className="eyebrow">Our Promise</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-brand-navy">We do not just say "we visited". We show you proof.</h2>
          <p className="mt-5 text-brand-slate/85 leading-relaxed">
            Every property owner wants one thing: confidence. Our process is designed to reduce doubt through clear reporting, photos, videos, visit records and structured follow-up — across plots, rentals, vacant homes and senior citizen care.
          </p>
          <ul className="mt-6 space-y-3 text-sm text-brand-slate/85">
            {[
              ["Chennai-based real estate team", ShieldCheck],
              ["Inspection-led property care", Camera],
              ["Transparent digital reporting", FileText],
              ["Local knowledge across OMR, ECR, Anna Nagar, Velachery, Tambaram, Porur, Chengalpattu", MapPin],
            ].map(([t, Icon]) => (
              <li key={t} className="flex items-start gap-2"><Icon size={18} className="text-brand-cyan mt-0.5" />{t}</li>
            ))}
          </ul>
          <Link to="/contact" className="btn-cyan mt-8" data-testid="about-cta">Book a Property Review</Link>
        </div>
        <div className="space-y-6">
          {[
            { n: "01", t: "Inspection-led mindset", b: "We never replace a visit with a phone call. Every report is field-verified before it reaches you." },
            { n: "02", t: "Time-zone-aware communication", b: "We coordinate updates around your country and time zone — not ours." },
            { n: "03", t: "Documentation discipline", b: "From rental agreements to tax receipts, everything lives in a vault you control." },
          ].map((c) => (
            <div key={c.n} className="card-flat p-7">
              <div className="font-display text-3xl text-brand-cyan font-bold">{c.n}</div>
              <div className="mt-2 font-display text-2xl text-brand-navy font-bold">{c.t}</div>
              <p className="mt-1 text-sm text-brand-slate/80 leading-relaxed">{c.b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
